import React, { useEffect, useState } from "react";

import { checkAdminAccess, useAdminUserContext, useNavigate, useParams } from "utils";

import { ErrorBoundary, MainPage, Tabs } from "components";

import { PlatformEmissionFactors } from "pages/admin/settings/PlatformEmissionFactors";
import { PlatformTerms } from "pages/admin/settings/PlatformTerms.tsx";
import { SettingDetails } from "pages/admin/settings/SettingDetails";
import { UserList } from "pages/admin/settings/UserList";
import { VerificationRecalculation } from "pages/admin/settings/VerificationRecalculation";

export const Settings = () => {
  const { section } = useParams();
  const { user } = useAdminUserContext();

  const [currentSection, setCurrentSection] = useState(false);
  const navigate = useNavigate();

  const tabList = [
    {
      name: "Admin users",
      key: "users",
      component: <UserList />,
    },
    {
      name: "Settings",
      key: "settings",
      component: <SettingDetails />,
    },
    {
      name: "Verification Recalculation",
      key: "verification-recalculation",
      component: <VerificationRecalculation />,
    },
    {
      name: "Calculations",
      key: "calculations",
      // component: <Calculations />,
      component: <p>Page under construction</p>,
    },
    {
      name: "Emission Factors",
      key: "emission-factors",
      component: <PlatformEmissionFactors />,
    },
    {
      name: "Platform Terms",
      key: "platform-terms",
      component: <PlatformTerms />,
    },
  ];

  const getTabItems = () => {
    const tabs = [];
    tabList.forEach((tab) => {
      if (checkAdminAccess(user?.role, `settings/${tab.key}`)) {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
        });
      } else {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
          disabled: true,
        });
      }
    });
    return tabs;
  };

  useEffect(() => {
    setCurrentSection(section);
  }, [section]);

  return (
    <MainPage pageName={"admin"}>
      <Tabs activeKey={currentSection} size="small" onChange={(v) => navigate({ pathname: `/settings/${v}` }, { replace: true })} items={getTabItems()} />
    </MainPage>
  );
};
